export default __webpack_public_path__ + "static/media/orderUp.8965805c.png";